/** `#connectors` — `template.html` dòng 974–993, thuộc tính `data-en`. */

const tiles: readonly string[] = [
  'Snowflake',
  'GitLab',
  'Linear',
  'Google Drive',
  'Jira',
  'Figma',
  'PostgreSQL',
  'Webhook / API',
];

export const connectors = {
  eyebrow: 'Connectors',
  heading: 'Connect the systems the work already lives in.',
  lead: 'Data sources and tools attach per workspace or per project, so an agent only ever sees what its project is allowed to see.',
  tiles,
};
